import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const LandsideTrafficIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M10.625 2V6.08163H13.375V2H17.5L23 22H13.375V16.5578H10.625V22H1L6.5 2H10.625ZM13.375 8.66667H10.625V13.8367H13.375V8.66667Z'
                fill='currentColor'
            />
        </>
    ),
})

LandsideTrafficIcon.displayName = 'LandsideTrafficIcon'
